(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["db-banner-slideshow"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.db-banner-carousel').forEach(function (section) {

    const slides = section.querySelectorAll('.db-banner-carousel__slide');
    const dots = section.querySelectorAll('.db-banner-carousel__dot');
    const prevBtn = section.querySelector('.db-banner-carousel__nav--prev');
    const nextBtn = section.querySelector('.db-banner-carousel__nav--next');

    if (!slides.length) return;

    let index = 0;
    const autoplay = section.dataset.autoplay === 'true';
    const interval = parseInt(section.dataset.interval, 10) || 5000;
    let timer;

    function getVisibleMedia(slide) {
      if (window.innerWidth <= 700) {
        return slide.querySelector('.db-mobile-video, .db-mobile');
      }
      return slide.querySelector('.db-desktop-video, .db-desktop, .db-banner-carousel__image');
    }

    function getVisibleVideo(slide) {
      if (window.innerWidth <= 700) {
        return slide.querySelector('.db-mobile-video');
      }
      return slide.querySelector('.db-desktop-video');
    }

    function pauseAllVideos() {
      section.querySelectorAll('video').forEach((video) => {
        video.pause();
      });
    }

    function setHeight() {
      const activeSlide = slides[index];
      const media = getVisibleMedia(activeSlide);

      if (!media) return;

      const applyHeight = () => {
        section.style.height = activeSlide.offsetHeight + 'px';
      };

      if (media.tagName === 'VIDEO') {
        if (media.readyState >= 1) {
          applyHeight();
        } else {
          media.addEventListener('loadedmetadata', applyHeight, { once: true });
        }
      } else if (media.tagName === 'IMG') {
        if (media.complete) {
          applyHeight();
        } else {
          media.onload = applyHeight;
        }
      } else {
        applyHeight();
      }
    }

    function goToSlide(i) {
      index = (i + slides.length) % slides.length;

      pauseAllVideos();

      slides.forEach((slide, s) => {
        slide.classList.toggle('is-active', s === index);
      });

      dots.forEach((dot, d) => {
        dot.classList.toggle('active', d === index);
      });

      const activeVideo = getVisibleVideo(slides[index]);
      if (activeVideo) {
        activeVideo.play().catch(() => {});
      }

      setHeight();
    }

    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(() => goToSlide(index + 1), interval);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goToSlide(i);
        startAutoplay();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        goToSlide(index - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        goToSlide(index + 1);
        startAutoplay();
      });
    }

    window.addEventListener('resize', () => {
      goToSlide(index);
    });

    section.querySelectorAll('.db-desktop-video').forEach((video) => {
      const wrapper = video.closest('.db-video-wrapper');

      video.addEventListener('loadeddata', () => {
        wrapper.classList.add('db-video-ready-desktop');
        setHeight();
      });

      if (video.readyState >= 2) {
        wrapper.classList.add('db-video-ready-desktop');
      }
    });

    section.querySelectorAll('.db-mobile-video').forEach((video) => {
      const wrapper = video.closest('.db-video-wrapper');

      video.addEventListener('loadeddata', () => {
        wrapper.classList.add('db-video-ready-mobile');
        setHeight();
      });

      if (video.readyState >= 2) {
        wrapper.classList.add('db-video-ready-mobile');
      }
    });

    slides[0].classList.add('is-active');
    goToSlide(0);
    startAutoplay();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
